module.exports = __webpack_public_path__ + "static/media/login-inventarios.ad9c09eb.jpg";